<template>
    <div class="most-popular-row">
        <div class="most-popular-left img-scale-in">
            <a :href="$store.state.hrefPrefix + '/articles/' + article.slug"><img v-if="article.blob" :src="article.blob.url" alt=""/></a>
        </div>
        <div class="most-popular-right">
            <div class="most-popular-top">
                <h2><a :href="$store.state.hrefPrefix + '/category/' + article.category.slug">{{article.category.category_languages[0].pivot.name}}</a></h2>
                <span style="color: #4F5359">{{ formattedCreatedAt}}</span>
            </div>
            <h3><a :href="$store.state.hrefPrefix + '/articles/' + article.slug">{{ article.article_languages[0].pivot.title }}</a></h3>
        </div>
    </div>
</template>

<script>
export default {
    name: "MostPopularArticle",
    props: {
        article: {
            type: Object,
            default: null
        }
    },
    computed: {
        formattedCreatedAt() {
            const date = new Date((this.article.published_at ?? this.article.created_at).replace(' ', 'T'));
            const options = { month: 'short', day: 'numeric', year: 'numeric' };
            let locale = 'en-US';
            switch (this.$store.state.language.code) {
                case 'ar':
                    locale = 'ar-LB';
                    break;
                case 'tr':
                    locale = 'tr-TR';
                    break;
            }
            return date.toLocaleDateString(locale, options).toUpperCase();
        }
    }
}
</script>

<style scoped>

</style>
